module.exports = __webpack_public_path__ + "img/fpx-logo.bf200c84.svg";